import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteCarbonProgramDraft } from "services";

import { DELETE_CARBON_PROGRAM_DRAFT, GET_CARBON_PROGRAM_DRAFT, GET_CARBON_PROGRAM_DRAFTS } from "consts";

export const useDeleteCarbonProgramDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [DELETE_CARBON_PROGRAM_DRAFT],
    mutationFn: deleteCarbonProgramDraft,
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_DRAFTS] });
      queryClient.removeQueries({ queryKey: [GET_CARBON_PROGRAM_DRAFT, id] });
    },
  });
};
